import React from "react";

export const QuestionSolver = () => {
  return (
    <div className="p-6 rounded-3xl bg-white shadow-md max-w-4xl mx-auto mt-10">
      {/* Back Button */}
      <div className="flex justify-end mb-4">
        <button className="px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold rounded-lg shadow">
          Back
        </button>
      </div>

      {/* Question */}
      <h2 className="text-lg font-semibold mb-6">
        Q1. Solve the quadratic equation: 2x² - 7x + 3 = 0
      </h2>

      {/* Math Solution Box */}
      <div className="border rounded-2xl p-6 mb-6 bg-gray-50">
        <img
          src="https://latex.codecogs.com/png.image?\dpi{110}x=\frac{-7\pm\sqrt{(-7)^2-4\cdot2\cdot3}}{2\cdot2}=\frac{-7\pm\sqrt{49-24}}{4}=\frac{-7\pm\sqrt{25}}{4}=\frac{-7\pm5}{4}"
          alt="Quadratic Solution"
          className="mx-auto mb-4"
        />
        <img
          src="https://latex.codecogs.com/png.image?\dpi{110}x=\frac{-7+5}{4}=\frac{-2}{4}=-\frac{1}{2}\quad,\quad x=\frac{-7-5}{4}=\frac{-12}{4}=-3"
          alt="Final Answers"
          className="mx-auto"
        />
      </div>

      {/* Hint Box */}
      <div className="bg-gray-100 border rounded-2xl p-6 mb-6">
        <div className="flex items-start gap-4 mb-4">
          <div className="text-purple-600 text-2xl">❓</div>
          <div>
            <h3 className="text-lg font-bold text-gray-700">
              You Seem to be stuck, Let’s work on this together
            </h3>
            <p className="text-gray-600 mt-2">
              You seem to have made a small error in first line.
              <br />
              Try to recall the formula once again.
            </p>
          </div>
        </div>

        {/* Hint Buttons */}
        <div className="flex gap-4 mt-4">
          <button className="px-6 py-2 bg-white border border-gray-400 rounded-full font-semibold text-gray-700 hover:bg-gray-200">
            Give Hint
          </button>
          <button className="px-6 py-2 bg-purple-600 hover:bg-purple-700 text-white font-semibold rounded-full">
            Step by Step Guidance
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuestionSolver;
